import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/down-payment-calculator',
  component: () => import('../../routes/DownPayment.svelte'),
  card: {
    id: 'down-payment',
    title: 'Down Payment Calculator',
    description: 'Calculate your down payment amount, loan-to-value ratio, and monthly mortgage payment based on home price and down payment percentage.',
    icon: 'home',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/down-payment-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Down Payment Calculator – Calculate LTV, PMI & Monthly Mortgage Payment',
    description: 'Free down payment calculator to determine your down payment amount, loan-to-value ratio, and estimated monthly mortgage payment. Enter home price, down payment percentage, and loan terms to see how much house you can afford.',
  },
};

export default meta;
